export default __webpack_public_path__ + "static/media/Title.19d3adc9.webp";